var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-list"},_vm._l((_vm.categoryList),function(item,key){return _c('div',{key:key,staticClass:"category-list__item",class:{
            active: _vm.choosenCategory.id == item.id,
        },on:{"click":function($event){return _vm.getTasksByCategory(item)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }